export const MAX_FILE_SIZE_MB = 7;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Theme colors
export const THEME = {
  primary: '#C0275E',
  background: '#F8EFF3',
  text: '#621C43',
};

export const baseInputClass =
  'w-full border border-[#C0275E] rounded-lg p-2 text-sm text-[#621C43] bg-[#F8EFF3] focus:outline-none focus:ring-2 focus:ring-[#C0275E]/50';

// Supported question types
export const SUPPORTED_QUESTION_TYPES = [
  // Basic input types
  'text',
  'integer',
  'decimal',
  'date',
  'date_month_year',
  'date_year',
  'time',
  'datetime',
  'note',
  // Location types
  'geopoint',
  'geotrace',
  'geoshape',
  // Selection types
  'select_one',
  'select_multiple',
  // Media types
  'audio',
  'video',
  'image',
  'file',
  'barcode',
  'signature',
  // Survey specific types
  'rating',
  'ranking',
  'rank_ranking_items',
  'yes_no',
  'yesno',
  'likert',
  'info',
  'information_note',
  'informational',
  'hyperlink',
  'trigger',
  'template_intro',
  'templateintro',
  // Group types
  'begin_group',
  'group',
  'end_group',
  'begin_repeat',
  // Additional types
  'header',
  'range_slider',
  'acknowledge',
] as const;

export type SupportedQuestionType = (typeof SUPPORTED_QUESTION_TYPES)[number];

// Helper to check if a type is supported
export const isSupportedType = (type: string): boolean => {
  const normalizedType = type?.toLowerCase?.() ?? '';
  // Check exact match
  if (SUPPORTED_QUESTION_TYPES.includes(normalizedType as SupportedQuestionType)) {
    return true;
  }
  // Check for select_one/select_multiple prefixes
  if (normalizedType.startsWith('select_one') || normalizedType.startsWith('select_multiple')) {
    return true;
  }
  // Check for rank ranking_items (with space)
  if (normalizedType === 'rank ranking_items') {
    return true;
  }
  return false;
};
